import * as React from 'react';

type Props = {
  text: string;
};

export class PageTitle extends React.PureComponent<Props> {
  public render() {
    return (
      <div className="page__title">
        <h1>{this.props.text}</h1>
      </div>
    );
  }
}
